import * as ACTION_TYPES from './holidayActionTypes';

export const holidayReducerInitialState = {
    holidayList: {
        data: undefined,
        isFetching: false,
        hasError: false,
        error: undefined
    },
    holidayNew: {
        data: undefined,
        isFetching: false,
        hasError: false,
        error: undefined
    },
    holidayEdit: {
        data: undefined,
        isFetching: false,
        hasError: false,
        error: undefined
    },
    holidayDelete: {
        data: undefined,
        isFetching: false,
        hasError: false,
        error: undefined
    },
    holidayToEdit: {},
    holidayTypeList: {
        data: undefined,
        isFetching: false,
        hasError: false,
        error: undefined
    }
};

export const holidayReducer = (state = holidayReducerInitialState, action) => {
    switch (action.type) {
        // list
        case ACTION_TYPES.LIST_HOLIDAY_REQUEST: {
            return {
                ...state,
                holidayList: {
                    ...state.holidayList,
                    isFetching: true,
                    hasError: false,
                    error: holidayReducerInitialState.holidayList.error
                }
            };
        }

        case ACTION_TYPES.LIST_HOLIDAY_REQUEST_SUCCESS: {
            const { data } = action.payload;
            return {
                ...state,
                holidayList: {
                    ...state.holidayList,
                    isFetching: false,
                    hasError: false,
                    error: holidayReducerInitialState.holidayList.error,
                    data
                }
            };
        }

        case ACTION_TYPES.LIST_HOLIDAY_REQUEST_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                holidayList: {
                    ...state.holidayList,
                    isFetching: false,
                    hasError: true,
                    data: holidayReducerInitialState.holidayList.data,
                    error
                }
            };
        }

        case ACTION_TYPES.CLEAR_LIST_HOLIDAY: {
            return {
                ...state,
                holidayList: {
                    ...holidayReducerInitialState.holidayList
                }
            };
        }

        //New holiday
        case ACTION_TYPES.NEW_HOLIDAY_REQUEST: {
            return {
                ...state,
                holidayNew: {
                    ...state.holidayNew,
                    isFetching: true,
                    hasError: false,
                    error: holidayReducerInitialState.holidayNew.error
                }
            };
        }

        case ACTION_TYPES.NEW_HOLIDAY_REQUEST_SUCCESS: {
            const { data } = action.payload;

            return {
                ...state,
                holidayNew: {
                    ...state.holidayNew,
                    isFetching: false,
                    hasError: false,
                    error: holidayReducerInitialState.holidayNew.error,
                    data
                }
            };
        }

        case ACTION_TYPES.NEW_HOLIDAY_REQUEST_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                holidayNew: {
                    ...state.holidayNew,
                    isFetching: false,
                    hasError: true,
                    data: holidayReducerInitialState.holidayNew.data,
                    error
                }
            };
        }

        //Edit holiday
        case ACTION_TYPES.EDIT_HOLIDAY_REQUEST: {
            return {
                ...state,
                holidayEdit: {
                    ...state.holidayEdit,
                    isFetching: true,
                    hasError: false,
                    error: holidayReducerInitialState.holidayEdit.error
                }
            };
        }

        case ACTION_TYPES.EDIT_HOLIDAY_REQUEST_SUCCESS: {
            const { data } = action.payload;

            return {
                ...state,
                holidayEdit: {
                    ...state.holidayEdit,
                    isFetching: false,
                    hasError: false,
                    error: holidayReducerInitialState.holidayEdit.error,
                    data
                }
            };
        }

        case ACTION_TYPES.EDIT_HOLIDAY_REQUEST_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                holidayEdit: {
                    ...state.holidayEdit,
                    isFetching: false,
                    hasError: true,
                    data: holidayReducerInitialState.holidayEdit.data,
                    error
                }
            };
        }

        case ACTION_TYPES.SET_HOLIDAY_TO_EDIT: {
            const { data } = action.payload;
            return {
                ...state,
                holidayToEdit: data
            }
        }

        //Delete Holiday
        case ACTION_TYPES.DELETE_HOLIDAY_REQUEST: {
            return {
                ...state,
                holidayDelete: {
                    ...state.holidayDelete,
                    isFetching: true,
                    hasError: false,
                    error: holidayReducerInitialState.holidayDelete.error
                }
            };
        }

        case ACTION_TYPES.DELETE_HOLIDAY_REQUEST_SUCCESS: {
            const { data } = action.payload;

            return {
                ...state,
                holidayDelete: {
                    ...state.holidayDelete,
                    isFetching: false,
                    hasError: false,
                    error: holidayReducerInitialState.holidayDelete.error,
                    data
                }
            };
        }

        case ACTION_TYPES.DELETE_HOLIDAY_REQUEST_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                holidayDelete: {
                    ...state.holidayDelete,
                    isFetching: false,
                    hasError: true,
                    data: holidayReducerInitialState.holidayDelete.data,
                    error
                }
            };
        }

        //Holiday Types List
        case ACTION_TYPES.HOLIDAY_TYPE_LIST_REQUEST: {
            return {
                ...state,
                holidayTypeList: {
                    ...state.holidayTypeList,
                    isFetching: true,
                    hasError: false,
                    error: holidayReducerInitialState.holidayTypeList.error
                }
            };
        }

        case ACTION_TYPES.HOLIDAY_TYPE_LIST_REQUEST_SUCCESS: {
            const { data } = action.payload;
            return {
                ...state,
                holidayTypeList: {
                    ...state.holidayTypeList,
                    isFetching: false,
                    hasError: false,
                    error: holidayReducerInitialState.holidayTypeList.error,
                    data
                }
            };
        }

        case ACTION_TYPES.HOLIDAY_TYPE_LIST_REQUEST_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                holidayTypeList: {
                    ...state.holidayTypeList,
                    isFetching: false,
                    hasError: true,
                    data: holidayReducerInitialState.holidayTypeList.data,
                    error
                }
            };
        }

        case ACTION_TYPES.CLEAR_HOLIDAY_TYPE_LIST: {
            return {
                ...state,
                holidayTypeList: {
                    ...holidayReducerInitialState.holidayTypeList
                }
            };
        }

        default: {
            return state
        }
    }
};

export const getHolidayReducer = state => state.holidayReducer;

// Holiday list
export const getHolidayList = state => getHolidayReducer(state)?.holidayList;
export const getHolidayListData = state => getHolidayList(state)?.data;
export const getHolidayListIsFetching = state => getHolidayList(state)?.isFetching;

// New Holiday
export const getHolidayCreate = state => getHolidayReducer(state)?.holidayNew;
export const getHolidayCreateIsFetching = state => getHolidayCreate(state)?.isFetching;


// Edit Holiday
export const getHolidayEditIsFetching = state => getHolidayReducer(state)?.holidayEdit?.isFetching;

//Delete Holiday
export const getHolidayDeleteIsFetching = state => getHolidayReducer(state)?.holidayDelete?.isFetching;

// Holiday to edit
export const getHolidayToEdit = state => getHolidayReducer(state)?.holidayToEdit;

// Holiday type list
export const getHolidayTypeList = state => getHolidayReducer(state)?.holidayTypeList;
export const getHolidayTypeListData = state => getHolidayTypeList(state)?.data;
export const getHolidayTypeListIsFetching = state => getHolidayTypeList(state)?.isFetching;
